import { buildMeetingPath } from '../../utils/url';
import { resolveMeetOrigin } from './meetOrigin';

/**
 * Open the meeting in a brand new window, leaving the current one untouched.
 *
 * This is the fallback for desktop shells that have no meeting window of their
 * own (SM-1186). Those builds hand every non-internal URL to the system browser,
 * so the call starts in the user's browser while TeamHub keeps running. Their
 * "internal" list covers the TeamHub hosts and loopback, so deployed Meet
 * origins go to the browser but a local `localhost:8081` Meet would load into
 * the shell instead — this path can only be exercised against a deployed Meet.
 *
 * The URL carries no popup flag or parent origin, so the room loads as
 * standalone Meet. A tab opened this way has no opener, which means no auth
 * handoff and no Meet Settings sync — accepted only because the alternatives on
 * those clients are replacing the TeamHub shell or a blocked-popup dead end.
 *
 * In a plain browser this behaves like any other popup and may itself be
 * blocked, which is why only the desktop path uses it.
 */
export const openMeetingInExternalWindow = (meetingId: string, password?: string | null): void => {
  // `buildMeetingPath` yields `/room` or `/room#passcode`.
  const [pathname, hash] = buildMeetingPath(meetingId, password).split('#');
  const url = new URL(pathname, resolveMeetOrigin());
  window.open(`${url.toString()}${hash ? `#${hash}` : ''}`, '_blank', 'noopener,noreferrer');
};
